import tableComponent from '../../components/tableComponent'

export const tableComponentMixin = {
  components: {
    tableComponent
  },
  data() {
    return {
      copiedLegend: []
    }
  },
  methods: {
    copyLegend(legendName) {
      if (legendName) {
        this.copiedLegend = this[legendName].slice()
      } else {
        this.copiedLegend = this.legend.slice();
      }
    },
    setDefaultLegend() {
      this.copiedLegend.forEach(item => {
        item.activeFilter = false;
        item.legendUp = true;
        item.legendDown = true;
      })
    },
    setActiveFilterLegend(index) {
      this.copiedLegend[index].activeFilter = true;
    },
    setLegendDown(index) {
      this.copiedLegend[index].legendDown = true;
      this.copiedLegend[index].legendUp = false;
    },
    setLegendUp(index) {
      this.copiedLegend[index].legendDown = false;
      this.copiedLegend[index].legendUp = true;
    },
    setLegendArr(legendName) {
      if (legendName) {
       this[legendName] = this.copiedLegend
      } else {
        this.legend = this.copiedLegend;
      }
    },
  }
}
